import React from 'react'
import { WContainer, Breadcrumbs } from '@next-nx/shared-ui/atoms'
import { CircleBox } from '@next-nx/shared-ui/molecules'
import { FaqListingSection } from '@next-nx/shared-ui/organisms'
import { Page } from '@next-nx/shared-ui/organisms'
import { CategorieFaqDetailInterface, CategoriaFaqInterface } from '@next-nx/utils/types'
import { useTrans, useTealium } from '@next-nx/hooks'
import { getTimestamp } from '@next-nx/utils'
import styles from './FaqListingTemplate.module.sass'


interface Props {
  categorie: CategorieFaqDetailInterface[]
  categoriaMain: CategoriaFaqInterface
  selectedFaq: string
}

const FaqListingTemplate = (props: Props) => {

  const { categorie, categoriaMain, selectedFaq } = props

  const t = useTrans()
  const { linkDataLayer } = useTealium()

  const handleTracking = () => {
    const action_timestamp = getTimestamp()
    
    linkDataLayer({
      virtual: 'action',
      action_name: 'contattaci',
      action_tech: 'click',
      action_type: 'accedi',
      action_timestamp,
      action_effect: 'accesso_pagina_contatti',
    })
  }

  return (
    <Page pagina={categoriaMain.pagina} className={`${styles.root}`}>
      <WContainer>
        <Breadcrumbs breadcrumbs={categoriaMain.pagina.breadcrumbs} className={styles.breadcrumbs} />
        <span className={styles.title}>{t('Come possiamo aiutarti?')}</span>
      </WContainer>
      <FaqListingSection
        categorie={categorie}
        categoriaMain={categoriaMain}
        selectedFaq={selectedFaq} />
      <WContainer className={styles.custom_wcontainer}>
        <CircleBox
          variant='horizontal'
          animationVariant='vertical'
          handleTracking={handleTracking}
          item={{
            image: undefined,
            name: t('Cerchi un’assistenza immediata?'),
            description: t('Un nostro consulente sarà a tua disposizione per rispondere a tutte le tue domande.'),
            url: '/contattaci',
            ctaLabel: t('Contattaci')
          }} />
      </WContainer>
    </Page>
  )
}

export default FaqListingTemplate
